<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M9.05774 1.13628C8.6091 0.712106 8.06414 0.5 7.4232 0.5H2.80773C2.16662 0.5 1.62179 0.712146 1.17298 1.13632C0.724383 1.56057 0.5 2.07569 0.5 2.68188V7.04547C0.5 7.65162 0.724257 8.16666 1.17298 8.59083C1.62175 9.01496 2.16675 9.22719 2.80773 9.22719H5.50003C5.82044 9.22719 6.09294 9.3333 6.31732 9.54536C6.54171 9.75731 6.65386 10.015 6.65386 10.3182V10.6816C6.65386 11.4847 6.35332 12.1701 5.75241 12.7384C5.15146 13.3064 4.42636 13.5905 3.57686 13.5905H2.80773C2.59926 13.5905 2.41904 13.6627 2.26673 13.8065C2.11455 13.9504 2.03839 14.1209 2.03839 14.3179V15.7726C2.03839 15.9693 2.11455 16.1401 2.26673 16.284C2.41917 16.4278 2.59922 16.5 2.80773 16.5H3.57691C4.41032 16.5 5.2056 16.3464 5.96286 16.0396C6.72008 15.7329 7.37508 15.318 7.928 14.7952C8.48079 14.2724 8.91953 13.6533 9.24403 12.9373C9.56847 12.2214 9.73076 11.4695 9.73076 10.6817V2.68172C9.73076 2.07553 9.50638 1.56045 9.05774 1.13628ZM19.8261 1.13632C19.3775 0.712146 18.8326 0.5 18.1915 0.5H13.5762C12.9351 0.5 12.3903 0.712146 11.9416 1.13632C11.493 1.56061 11.2688 2.07569 11.2688 2.68188V7.04547C11.2688 7.65162 11.493 8.16666 11.9416 8.59083C12.3903 9.01496 12.9352 9.22719 13.5762 9.22719H16.2685C16.5889 9.22719 16.8616 9.3333 17.086 9.54536C17.3101 9.75743 17.4225 10.015 17.4225 10.3182V10.6816C17.4225 11.4847 17.122 12.1701 16.521 12.7384C15.92 13.3064 15.1951 13.5905 14.3455 13.5905H13.5762C13.3679 13.5905 13.1875 13.6627 13.0354 13.8065C12.8831 13.9504 12.8069 14.1209 12.8069 14.3179V15.7726C12.8069 15.9693 12.8831 16.1401 13.0354 16.284C13.1875 16.4278 13.3679 16.5 13.5762 16.5H14.3455C15.1788 16.5 15.9741 16.3464 16.7314 16.0396C17.4885 15.7329 18.1434 15.318 18.6964 14.7952C19.2493 14.2724 19.6883 13.6531 20.0126 12.9373C20.337 12.2215 20.4993 11.4695 20.4993 10.6817V2.68172C20.4992 2.07553 20.275 1.56045 19.8261 1.13632Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgForums',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>